module.exports = __webpack_public_path__ + "static/media/modum.b39a0931.png";